import { EmailField, EmailFieldProps } from '@components/email-field';
import { FieldMappingData } from '@components/text-editors/addons/field-mapping';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormEmailFieldProps<T = unknown> = FormFieldProps<EmailFieldProps, T> &
  FieldMappingData;

export function FormEmailField<T>(props: FormEmailFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping' });

  return <EmailField {...props} {...formFieldProps} />;
}
